import { CartProduct } from './cartProduct'
import React from 'react'
import { observer } from 'mobx-react-lite'
import { StepController } from '../../datastores/stepController'
import { RootStore } from '../../datastores/rootStore'

export const CartContentProducts = observer(() => {
  let cart = RootStore.getInstance().cart
  const [ga4AddonsIds, setGa4AddonsIds] = React.useState([])

  return (
    <div className='mtt-cart-products-container'>
      {cart.eventGroups.map(eventGroup => {
        return (
          <React.Fragment key={eventGroup.id}>
            <CartProduct
              key={eventGroup.id}
              eventGroup={eventGroup}
              hasError={StepController.getInstance().validationResults.has(`eventGroups.${eventGroup.id}`)}
              ga4AddonsIds={ga4AddonsIds}
              setGa4AddonsIds={setGa4AddonsIds}
            />
            {StepController.getInstance().validationResults.has(`eventGroups.${eventGroup.id}`) ? (
              <div className={'mtt-cart-product__error'}>
                {StepController.getInstance().validationResults.get(`eventGroups.${eventGroup.id}`)}
              </div>
            ) : null}
          </React.Fragment>
        )
      })}
      {StepController.getInstance().validationResults.has('eventGroups') ? (
        <div className={'mtt-cart-products-container__error'}>
          {StepController.getInstance().validationResults.get('eventGroups')}
        </div>
      ) : null}
    </div>
  )
})
